module.exports = __webpack_public_path__ + "media/images/emblems/Spiez-coat_of_arms-a92c22527b32a0b399fc3653ecf7cb22.svg";